<template>
	<CreationWizard
		mode="workflow"
		:initialState="$props"
		@workflow-created="onWorkflowCreated"
		@close-wizard="closeWizard"
		@start-creation-process="startCreationProcess"
		extension-mode
	/>
</template>

<script>
import CreationWizard from '@/components/CreationWizard/CreationWizard.vue';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
export default {
	name: 'ExtensionCreationWizard',
	props: {
		featureTypeId: { type: String },
		appId: { type: Number },
		slug: { type: String },
		serviceWorkspaceId: { type: [String, Number] },
		currentUrl: { type: String },
		toolPlacement: { type: String },
		elementType: { type: String },
	},
	components: { CreationWizard },
	methods: {
		closeWizard() {
			return ExtensionCommunicationService.closeWizard(window);
		},
		onWorkflowCreated(workflow) {
			return ExtensionCommunicationService.onWorkflowCreated(window, workflow);
		},
		startCreationProcess(creationProcessMessage) {
			return ExtensionCommunicationService.startCreationProcess(creationProcessMessage);
		},
	},
};
</script>

<style lang="scss" scoped></style>
